import { useAgenciesStore } from '@ezio/features/agencies/store'
import { useAlertsStore } from '@ezio/features/alerts/store'
import { useAuthStore } from '@ezio/features/auth/store'
import { useBankStore } from '@ezio/features/bank/store'
import { useCardsStore } from '@ezio/features/cards/store'
import { useUsersStore } from '@ezio/features/users/store'
import { useNetworksStore } from '@ezio/features/networks/store'
import { useOrganizationsStore } from '@ezio/features/organizations/store'
import { usePayoutsStore } from '@ezio/features/payouts/store'
import { usePayinsStore } from '@ezio/features/payins/store'
import { useTransactionsStore } from '@ezio/features/transactions/store'
import { useTicketBoardsStore } from '@ezio/features/ticket-boards/store'
import { useTicketsStore } from '@ezio/features/tickets/store'
import { useTicketCommentsStore } from '@ezio/features/ticket-comments/store'
import { useClientsStore } from '@ezio/features/clients/store'
import { useEmployeesStore } from '@ezio/features/employees/store'
import { useSearchStore } from '@ezio/features/search/store'
import { useTagsStore } from '@ezio/features/tags/store'
import { usePermissionsStore } from '@ezio/features/permissions'

const init = async () => {}

const reset = () => {
    useAgenciesStore().reset()
    useAlertsStore().reset()
    useAuthStore().reset()
    useBankStore().reset()
    useUsersStore().reset()
    useNetworksStore().reset()
    useOrganizationsStore().reset()
    usePayoutsStore().reset()
    usePayinsStore().reset()
    useTagsStore().reset()
    useTransactionsStore().reset()
    useTicketBoardsStore().reset()
    useTicketsStore().reset()
    useTicketCommentsStore().reset()
    useClientsStore().reset()
    useEmployeesStore().reset()
    usePermissionsStore().reset()
}

export { init, useAgenciesStore, useAlertsStore, useAuthStore, useBankStore, useCardsStore, useClientsStore, useEmployeesStore, useUsersStore, useNetworksStore, useOrganizationsStore, usePayoutsStore, usePayinsStore, usePermissionsStore, useTagsStore, useTransactionsStore, useTicketBoardsStore, useTicketsStore, useTicketCommentsStore, useSearchStore, reset }
